import React, { useEffect, useRef, useState } from "react";

type LazyMountOnceProps = {
  children: React.ReactNode;
  minHeight?: number;
};

const LazyMountOnce = ({ children, minHeight = 1 }: LazyMountOnceProps) => {
  const [mounted, setMounted] = useState(false);
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (mounted) return;
    const node = sentinelRef.current;
    if (!node) return;

    if (typeof IntersectionObserver === "undefined") {
      setMounted(true);
      return;
    }

    let didDisconnect = false;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setMounted(true);
          observer.disconnect();
          didDisconnect = true;
        }
      },
      { rootMargin: "200px 0px" }
    );

    observer.observe(node);
    return () => {
      if (!didDisconnect) observer.disconnect();
    };
  }, [mounted]);

  if (mounted) {
    return <>{children}</>;
  }

  return <div ref={sentinelRef} style={{ minHeight }} />;
};

export default LazyMountOnce;
